const numberPhone = '+51906753241';
const whatsAppMessage = 'Hola, bienvenidos a Proyment!';

export { numberPhone, whatsAppMessage };
